export const checkout = [
  {
    path: "dados-pessoais",
    name: "DadosPessoaisFixa",
    component: () =>
      import(
        /* webpackChunkName: "dados-pessoais-fixa" */ "@views/fixa/dados-pessoais.vue"
      ),
  },
  {
    path: "endereco",
    name: "EnderecoFixa",
    component: () =>
      import(
        /* webpackChunkName: "endereco-fixa" */ "@views/fixa/endereco-fixa.vue"
      ),
  },
  {
    path: "pagamento",
    name: "PagamentoFixa",
    component: () =>
      import(
        /* webpackChunkName: "pagamento-fixa" */ "@views/fixa/pagamento.vue"
      ),
  },
  {
    path: "complemento",
    name: "ComplementarDadosFixa",
    component: () =>
      import(
        /* webpackChunkName: "complemento-fixa" */ "@views/complemento.vue"
      ),
  },
];

export const escolhaPlano = [
  {
    path: "consulta-cobertura",
    name: "ConsultaViabilidade",
    component: () =>
      import(
        /* webpackChunkName: "consulta-viabilidade-fixa" */ "@views/fixa/consulta-viabilidade.vue"
      ),
  },
  {
    path: "escolha-plano",
    name: "EscolhaPlano",
    component: () =>
      import(
        /* webpackChunkName: "escolha-plano-fixa" */ "@views/fixa/escolha-plano.vue"
      ),
  },
  {
    path: "sem-cobertura",
    name: "ErroViabilidade",
    component: () =>
      import(
        /* webpackChunkName: "erro-viabilidade-fixa" */ "@views/fixa/erro-viabilidade.vue"
      ),
  },
  {
    path: "sem-cobertura-lead-enviado",
    name: "ErroViabilidadeLead",
    component: () =>
      import(
        /* webpackChunkName: "erro-viabilidade-fixa-fixa" */ "@views/fixa/erro-viabilidade-lead.vue"
      ),
  },
  {
    path: "parabens",
    name: "ParabensFixa",
    component: () =>
      import(/* webpackChunkName: "parabens-fixa" */ "@views/parabens.vue"),
  },
];
